import { Dropdown, Upload, Input, Tooltip, notification } from "antd";
import {
  ArrowUpDown,
  ChevronDown,
  CircleX,
  ListFilter,
  Plus,
  RefreshCcw,
  Search,
  UploadIcon,
  User,
  UserRoundX,
  Users2,
  X,
} from "lucide-react";

import React, { useState } from "react";
import Loader from "../../../Loader";
import FilterResumeModal from "./FilterResumeModal";
import WebUtils from "../../../../utils/WebUtils";
import { uploadResumeApi } from "../../../../api/b2b-candidate";
import Utils from "../../../../utils/Utils";

function ResumeSearchSec({
  resumes,
  searchText,
  setSearchText,
  setSearchValue,
  searchValue,
  selectedUserIds,
  setDeleteResumeTrigger,
  setSortBy,
  sortBy,
  sortItems,
  setResumeState,
  resumeState,
}) {
  const userDetail = Utils.getUserDetail();
  const [loading, setLoading] = useState(false);
  const [resumeFilterFlag, setResumeFilterFlag] = useState(false);

  const props = {
    accept: ".pdf",
    showUploadList: false,
    beforeUpload: (file) => {
      uploadResume(file);
      return false; // prevent automatic upload
    },
  };

  const uploadResume = (file) => {
    const url = `${uploadResumeApi}`;
    setLoading(true);
    let formData = new FormData();
    formData.append("resumeFile", file);
    formData.append("organizationId", userDetail?.organizationId);
    formData.append("userIdentifier", userDetail?.userIdentifier);

    WebUtils.httpOperations(url, formData, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setDeleteResumeTrigger((prev) => prev + 1);
          notification.success({
            message: "Success",
            description: "Resume uploaded successfully!",
          });
        } else {
          notification.error({
            message: "Error",
            description: "Resume upload failed!",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const assignItems = [
    {
      key: "student",
      label: (
        <div className="flex items-center gap-2 text-[.85rem] p-[.25rem]">
          <User size={16} />
          Assign to Student
        </div>
      ),
    },
    {
      key: "batch",
      label: (
        <div className="flex items-center gap-2 text-[.85rem] p-[.25rem]">
          <Users2 size={16} />
          Assign to Batch
        </div>
      ),
    },
  ];

  return (
    <>
      {loading && <Loader />}
      {resumeFilterFlag && (
        <FilterResumeModal
          resumeFilterFlag={resumeFilterFlag}
          setResumeFilterFlag={setResumeFilterFlag}
          setResumeState={setResumeState}
          resumeState={resumeState}
        />
      )}
      <div className="">
        <div className="flex justify-between mb-3 gap-2 flex-wrap">
          <div className="flex gap-x-[.65rem] gap-y-2 items-center flex-wrap">
            <div>
              <Input
                prefix={<Search size={15} />}
                suffix={
                  (searchText || searchValue) && (
                    <button
                      type="button"
                      onClick={() => {
                        setSearchText("");
                        setSearchValue("");
                      }}
                      className="flex items-center justify-center text-gray-500 hover:text-gray-700"
                    >
                      <CircleX size={15} />
                    </button>
                  )
                }
                placeholder="Search students..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onPressEnter={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <button
              onClick={() => setResumeFilterFlag(true)}
              className={`flex gap-x-[6px] items-center border-[1px]  rounded-md px-3 py-[5px] text-[.85rem] text-[#344054] ${resumeState !== "ALL" ? "border-orange-300 bg-orange-100" : "border-gray-300"} `}
            >
              <ListFilter size={14} />
              Filter{" "}
              {resumeState !== "ALL" && (
                <X
                  className="cursor-pointer hover:text-orange-500 duration-200 transition-all ease-in-out"
                  onClick={(e) => {
                    setResumeState("ALL");
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  size={14}
                />
              )}
            </button>
            <Dropdown
              menu={{
                // items: sortItems,
                items: sortItems.map((item) => ({
                  ...item,
                  className:
                    sortBy === item.key
                      ? "!bg-orange-50 !text-[#DC6803] font-semibold"
                      : "",
                })),
                selectedKeys: [sortBy],
                onClick: ({ key }) => {
                  setSortBy(key);
                },
              }}
              trigger={["click"]}
            >
              <button className="flex gap-x-[6px] items-center border-[1px] border-gray-300 rounded-md px-3 py-[5px] text-[.85rem] text-[#344054]">
                <ArrowUpDown size={14} />
                Sort by
              </button>
            </Dropdown>
            {/* <Tooltip
            overlayInnerStyle={{
              backgroundColor: "black",
              borderRadius: 8,
              fontSize: ".85rem",
              padding: "6px 10px",
            }}
            title="Refresh Table"
          >
            <button
              className="ml-1"
              onClick={() => setRefressGetApi((prev) => prev + 1)}
            >
              <RefreshCcw color="#344054" size={19} />
            </button>
          </Tooltip> */}
          </div>
          <div className="flex gap-x-3 gap-y-2 items-center flex-wrap">
            {/* <Dropdown
              menu={{
                items: assignItems,
                onClick: ({ key }) => {
                  if (key === "batch") {
                    // setAssignGuideBatchFlag(true);
                  }
                  if (key === "student") {
                    // setAssignCandidateBatchFlag(true);
                  }
                },
              }}
              trigger={["click"]}
              placement="bottomLeft"
              overlayClassName="bulk-actions-dropdown"
              className="px-2 rounded-[6px]"
            >
              <button
                className="flex items-center gap-[.5rem] text-[#1D2939] hover:brightness-[1.1] transition-all duration-200 ease-in-out 
            px-[.9rem] py-[.45rem] border-[1px] border-[#EDC043] rounded-[6px] bg-[#EDC043]"
              >
                <span className="flex gap-3 items-center">
                  <span className="font-semibold text-[.8rem] flex gap-[.5rem] items-center">
                    Upload Resume
                  </span>
                </span>
                <span className="">
                  <ChevronDown size={19} />
                </span>
              </button>
            </Dropdown> */}
            <Upload {...props}>
              <button className="btn-orange px-4 py-[.4rem] text-[.82rem] rounded-[6px] flex items-center gap-2 justify-center">
                <UploadIcon size={17} />
                Upload Resume
              </button>
            </Upload>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResumeSearchSec;
